import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { getIsUserLogged } from '@shared/selectors';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getShopName from '@core/reducers/shop/selectors/getShopName';
import getShopIsFavorite from '@core/reducers/shop/selectors/getShopIsFavorite';
import getShowOnlinePaymentTooltip from '@shopDetails/selectors/getShowOnlinePaymentTooltip';
import toggleFavorite from '@core/reducers/shop/actions/toggleFavorite';
import closeOnlinePaymentTooltip from '@shopDetails/actions/closeOnlinePaymentTooltip';
import trackShopInfoClicked from '@shopDetails/tracking/actions/trackShopInfoClicked';
import trackShareButtonClicked from '@shopDetails/tracking/actions/trackShareButtonClicked';
import ShopHeaderActions from './ShopHeaderActions';

const mapStateToProps = createStructuredSelector({
  shopId: getShopId,
  shopName: getShopName,
  shopIsFavorite: getShopIsFavorite,
  isUserLogged: getIsUserLogged,
  showOnlinePaymentTooltip: getShowOnlinePaymentTooltip,
});

const mapDispatchToProps = {
  onToggleFavorite: toggleFavorite,
  closeOnlinePaymentTooltip,
  trackShopInfoClicked,
  trackShareButtonClicked,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ShopHeaderActions);
